import type { HTMLAttributes } from "react";

import clsx from "clsx";
import { cn } from "@/lib/utils";

const sizeType = {
  lg: "!text-textLg",
  md: "!text-textMd",
  base: "!text-textBase",
  sm: "!text-textSm",
  xs: "!text-textXs",
};

export const weightType = {
  light: "!font-matterLight",
  base: "!font-matterRegular",
  medium: "!font-matterMedium",
  semiBold: "!font-matterSemibold",
  bold: "!font-matterBold",
};

interface ParagraphProps extends HTMLAttributes<HTMLParagraphElement> {
  children?: React.ReactNode;
  className?: string;
  size?: keyof typeof sizeType;
  weight?: keyof typeof weightType;
}

export default function Paragraph({
  children,
  className,
  size = "base",
  weight = "base",
  ...props
}: ParagraphProps) {
  const classNames = clsx(sizeType[size], weightType[weight], className);

  return (
    <p {...props} className={cn(classNames)}>
      {children}
    </p>
  );
}
